import { render, staticRenderFns } from "./customProLine.vue?vue&type=template&id=4847040a&scoped=true&"
import script from "./customProLine.vue?vue&type=script&lang=js&"
export * from "./customProLine.vue?vue&type=script&lang=js&"
import style0 from "./customProLine.vue?vue&type=style&index=0&id=4847040a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847040a",
  null
  
)

export default component.exports